import api from '@/services/api';

export const tagService = {
  getAll,
  getById,
  create,
  update,
  destroy
}

function getAll() {
  return api.get(`${process.env.VUE_APP_ROOT_API}/tags`);
}

function getById(id) {
  return api.get(`${process.env.VUE_APP_ROOT_API}/tags/${id}`);
}

function create(tag) {
  return api.post(`${process.env.VUE_APP_ROOT_API}/tags`, tag);
}

function update(tag) {
  return api.put(`${process.env.VUE_APP_ROOT_API}/tags/${tag._id}`, tag);
}

function destroy(id) {
  return api.delete(`${process.env.VUE_APP_ROOT_API}/tags/${id}`);
}